<template>
    <table-tag :superTag="isSuperTag">
        <v-icon v-if="isSuperTag"
                class="pl-1"
                left
                x-small
                v-text="'far fa-sparkles'" />
        <span>
            {{ sanitizedName }}
        </span>
    </table-tag>
</template>

<script>
import { defineComponent } from 'vue'

import TableTag from './table-tag.vue'

export default defineComponent({
    components: { TableTag },
    props: {
        value: {
            type: String,
            required: true
        }
    },
    computed: {
        sanitizedName() {
            return this.value.replace(/^§/, '')
        },
        isSuperTag() {
            return this.value.startsWith('§')
        }
    }
})
</script>
